import type { Journey } from "../../types/journey";

export const IVF_JOURNEY_ES: Journey = {
	id: "ivf",
	type: "ivf",
	name: "Recorrido FIV",
	treatmentType: "Tratamiento FIV",
	totalSteps: 9,
	steps: [
		{
			id: "ivf-step-1-initial-consultation",
			order: 1,
			title: "Consulta inicial",
			description:
				"En este paso comienza a tomar forma tu camino de fertilidad. Trae tu historial médico, conoce a tu especialista y sal con un plan personalizado de tratamiento.",
			estimatedDateRange: "[Pre-cycle] Est. Week 1 – Week 2",
			status: "completed",
			subSteps: [
				{
					id: "ivf-step-1-initial-consultation-ss-01",
					title: "Preparar documentación e historial",
				},
				{
					id: "ivf-step-1-initial-consultation-ss-02",
					title: "Reservar y asistir a la consulta",
				},
				{
					id: "ivf-step-1-initial-consultation-ss-03",
					title: "Revisar resultados y próximos pasos",
				},
			],
			highlight: {
				dayCount: "7–14 días",
				monitoringSchedule:
					"Prepara tu historial médico antes de la cita; Revisa el plan de tratamiento dentro de 24 horas tras la consulta",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Es común sentirse abrumada tras una primera consulta. Anotar tus preguntas con antelación ayuda a muchas personas a sentirse más en control.",
				milestone: "Plan de tratamiento recibido, est. Semana 2",
				currentDayLabel: "Día [N] de ~14",
				estimatedLengthDays: 14,
			},
			tasks: [
				{
					id: "ivf-step-1-initial-consultation-ss1-task1",
					title: "Completar: Formulario de admisión",
					description: "Datos personales para tu archivo clínico",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-1-initial-consultation-ss-01",
					subStepTitle: "Preparar documentación e historial",
					progressTotal: 8,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-1-initial-consultation-ss1-task2",
					title: "Completar: Cuestionario de salud",
					description: "Información de historial médico para tu próxima visita",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-1-initial-consultation-ss-01",
					subStepTitle: "Preparar documentación e historial",
					progressTotal: 12,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-1-initial-consultation-ss1-task3",
					title: "Subir: Historial médico previo",
					description: "Historial de tratamientos previos y hallazgos",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-1-initial-consultation-ss-01",
					subStepTitle: "Preparar documentación e historial",
				},
				{
					id: "ivf-step-1-initial-consultation-ss1-task4",
					title: "Subir: Carta de derivación",
					description: "Carta de tu médico de cabecera o derivante",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-1-initial-consultation-ss-01",
					subStepTitle: "Preparar documentación e historial",
				},
				{
					id: "ivf-step-1-initial-consultation-ss1-task5",
					title: "Subir: Documentos de identidad",
					description: "Pasaporte o identificación oficial con foto",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-1-initial-consultation-ss-01",
					subStepTitle: "Preparar documentación e historial",
				},
				{
					id: "ivf-step-1-initial-consultation-ss2-task1",
					title: "Reservar: Consulta inicial con especialista",
					description: "Primera cita con tu especialista en fertilidad",
					category: "clinical",
					deadline: "Lo antes posible",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-1-initial-consultation-ss-02",
					subStepTitle: "Reservar y asistir a la consulta",
				},
				{
					id: "ivf-step-1-initial-consultation-ss2-task2",
					title: "Completar: Evaluación pre-tratamiento",
					description: "Datos de salud y estilo de vida para tu equipo",
					category: "clinical",
					deadline: "Antes de tu primera cita",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-1-initial-consultation-ss-02",
					subStepTitle: "Reservar y asistir a la consulta",
					progressTotal: 6,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-1-initial-consultation-ss3-task1",
					title: "Revisar y firmar: Resumen del plan de tratamiento",
					description: "Tu plan personalizado de estimulación para revisar",
					category: "clinical",
					deadline: "Dentro de 24 horas tras la consulta",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-1-initial-consultation-ss-03",
					subStepTitle: "Revisar resultados y próximos pasos",
				},
				{
					id: "ivf-step-1-initial-consultation-ss3-task2",
					title: "Completar: Datos de facturación",
					description: "Información de seguro y pago para tu archivo",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-1-initial-consultation-ss-03",
					subStepTitle: "Revisar resultados y próximos pasos",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-1-initial-consultation-ss3-task3",
					title: "Subir: Autorización del seguro",
					description: "Carta de pre-aprobación de tu proveedor de seguro",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-1-initial-consultation-ss-03",
					subStepTitle: "Revisar resultados y próximos pasos",
				},
			],
			faqs: [
				{
					id: "ivf-step-1-initial-consultation-faq-1",
					question: "¿Qué debo llevar a mi primera cita?",
					answer:
						"Lleva los resultados de cualquier prueba de fertilidad previa, una lista completa de medicamentos actuales, información del seguro y una identificación oficial con foto. Si has tenido tratamientos de fertilidad anteriores, incluye esos registros. Cualquier estudio o ecografía reciente también es útil. La especialista te dirá qué pruebas adicionales se necesitan según tu historial.",
				},
				{
					id: "ivf-step-1-initial-consultation-faq-2",
					question: "¿Cuánto tiempo suele tomar este primer paso?",
					answer:
						"La consulta inicial dura típicamente 60–90 minutos. Después, generalmente toma 5–10 días para que lleguen todos los resultados de las pruebas y la clínica prepare un plan personalizado. Desde la primera cita hasta tener un plan completo, suele ser alrededor de 2 semanas.",
				},
				{
					id: "ivf-step-1-initial-consultation-faq-3",
					question: "¿Mi pareja necesita asistir a este paso?",
					answer:
						"Si tienes pareja, asistir juntos es muy recomendable — ambos pueden necesitar pruebas, y muchas decisiones se toman en pareja. Si no es posible, la mayoría de las clínicas pueden organizar una cita de seguimiento para incluir a la pareja por separado o por video llamada.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Consulta inicial.",
		},
		{
			id: "ivf-step-2-fertility-testing",
			order: 2,
			title: "Pruebas de fertilidad",
			description:
				"Este paso construye una línea base de fertilidad completa mediante análisis de sangre, ecografías y evaluación uterina — dándole al equipo clínico los datos necesarios para diseñar el protocolo correcto.",
			estimatedDateRange:
				"Est. Apr 1 – Apr 14, 2026 [Pre-cycle, CD2–CD3 for baseline scan]",
			estimatedStartDate: "2026-04-01",
			status: "completed",
			subSteps: [
				{
					id: "ivf-step-2-fertility-testing-ss-01",
					title: "Pruebas de reserva ovárica",
				},
				{
					id: "ivf-step-2-fertility-testing-ss-02",
					title: "Panel hormonal y ecografía basal",
				},
				{
					id: "ivf-step-2-fertility-testing-ss-03",
					title: "Evaluación uterina",
				},
				{
					id: "ivf-step-2-fertility-testing-ss-04",
					title: "Pruebas de pareja / esperma",
				},
				{
					id: "ivf-step-2-fertility-testing-ss-05",
					title: "Detección genética de portadores (opcional)",
				},
			],
			highlight: {
				dayCount: "7–14 días",
				monitoringSchedule:
					"Asiste a la ecografía basal en el DC2 o DC3; Notifica a la clínica inmediatamente cuando empiece tu período (Día 1)",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Esperar resultados puede generar una mezcla de esperanza y ansiedad. La mayoría llegan en pocos días, y cada número — sea cual sea — es información que ayuda a construir un mejor plan.",
				milestone: "Todos los resultados disponibles, est. 14 abr",
				currentDayLabel: "Día [N] de ~14",
				estimatedLengthDays: 14,
			},
			tasks: [
				{
					id: "ivf-step-2-fertility-testing-ss1-task1",
					title: "Reservar: Análisis de sangre AMH",
					description: "Mide tu reserva ovárica antes del tratamiento",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-2-fertility-testing-ss-01",
					subStepTitle: "Pruebas de reserva ovárica",
				},
				{
					id: "ivf-step-2-fertility-testing-ss1-task2",
					title: "Análisis: Análisis de sangre AMH",
					description: "Análisis de reserva ovárica para tu protocolo",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-2-fertility-testing-ss-01",
					subStepTitle: "Pruebas de reserva ovárica",
				},
				{
					id: "ivf-step-2-fertility-testing-ss1-task3",
					title: "Subir: Resultados de AMH",
					description: "Resultados del análisis de reserva ovárica",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-2-fertility-testing-ss-01",
					subStepTitle: "Pruebas de reserva ovárica",
				},
				{
					id: "ivf-step-2-fertility-testing-ss2-task1",
					title: "Notificar: Período comenzó — Día 1",
					description:
						"Registra el día 1 del ciclo para programar tu ecografía basal",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-2-fertility-testing-ss-02",
					subStepTitle: "Panel hormonal y ecografía basal",
				},
				{
					id: "ivf-step-2-fertility-testing-ss2-task2",
					title: "Reservar: Ecografía basal",
					description: "Ecografía de día 2–3 antes de iniciar la estimulación",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-2-fertility-testing-ss-02",
					subStepTitle: "Panel hormonal y ecografía basal",
				},
				{
					id: "ivf-step-2-fertility-testing-ss2-task3",
					title: "Análisis: Panel hormonal — E2, FSH, LH",
					description: "Niveles hormonales basales antes de la estimulación",
					category: "clinical",
					deadline: "Día 2 o 3 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-2-fertility-testing-ss-02",
					subStepTitle: "Panel hormonal y ecografía basal",
				},
				{
					id: "ivf-step-2-fertility-testing-ss2-task4",
					title: "Análisis: Recuento de folículos antrales",
					description:
						"Recuento ecográfico de folículos en reposo en ambos ovarios",
					category: "clinical",
					deadline: "Día 2 o 3 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-2-fertility-testing-ss-02",
					subStepTitle: "Panel hormonal y ecografía basal",
				},
				{
					id: "ivf-step-2-fertility-testing-ss3-task1",
					title: "Reservar: Evaluación uterina",
					description: "Evalúa la cavidad uterina antes de tu ciclo de FIV",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-2-fertility-testing-ss-03",
					subStepTitle: "Evaluación uterina",
				},
				{
					id: "ivf-step-2-fertility-testing-ss3-task2",
					title: "Análisis: Evaluación uterina",
					description:
						"Histerosonografía o histeroscopia de la cavidad uterina",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-2-fertility-testing-ss-03",
					subStepTitle: "Evaluación uterina",
				},
				{
					id: "ivf-step-2-fertility-testing-ss4-task1",
					title: "Reservar: Seminograma",
					description:
						"Análisis de esperma de la pareja — coordina con tu clínica",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-2-fertility-testing-ss-04",
					subStepTitle: "Pruebas de pareja / esperma",
				},
				{
					id: "ivf-step-2-fertility-testing-ss4-task2",
					title: "Análisis: Seminograma",
					description: "Conteo, motilidad y morfología del esperma",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-2-fertility-testing-ss-04",
					subStepTitle: "Pruebas de pareja / esperma",
				},
				{
					id: "ivf-step-2-fertility-testing-ss4-task3",
					title: "Subir: Informe del seminograma",
					description: "Resultados del laboratorio para tu archivo compartido",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-2-fertility-testing-ss-04",
					subStepTitle: "Pruebas de pareja / esperma",
				},
				{
					id: "ivf-step-2-fertility-testing-ss5-task1",
					title: "Reservar: Detección genética de portadores",
					description: "Estudio genético opcional recomendado antes de FIV",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-2-fertility-testing-ss-05",
					subStepTitle: "Detección genética de portadores (opcional)",
				},
				{
					id: "ivf-step-2-fertility-testing-ss5-task2",
					title: "Análisis: Detección genética de portadores",
					description: "Detección de condiciones genéticas recesivas",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-2-fertility-testing-ss-05",
					subStepTitle: "Detección genética de portadores (opcional)",
				},
				{
					id: "ivf-step-2-fertility-testing-ss5-task3",
					title: "Notificar: Resultados recibidos",
					description:
						"Informa a tu equipo que los resultados de portadores están listos",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-2-fertility-testing-ss-05",
					subStepTitle: "Detección genética de portadores (opcional)",
				},
			],
			faqs: [
				{
					id: "ivf-step-2-fertility-testing-faq-1",
					question: "¿Qué mide realmente la prueba de AMH?",
					answer:
						"La AMH — Hormona Antimulleriana — es producida por los folículos pequeños en los ovarios y proporciona una estimación del suministro restante de óvulos, conocido como reserva ovárica. Ayuda al equipo clínico a calibrar el protocolo de estimulación adecuado, pero no predice por sí sola la calidad de los óvulos ni el éxito del embarazo. Es solo una pieza del rompecabezas.",
				},
				{
					id: "ivf-step-2-fertility-testing-faq-2",
					question: "¿Es necesario el ayuno antes de los análisis de sangre?",
					answer:
						"La mayoría de los análisis de fertilidad — incluyendo la AMH y los paneles hormonales del día 2 — no requieren ayuno. Siempre vale la pena confirmar con la clínica el día anterior, ya que algunos paneles combinados pueden tener requisitos específicos (como evitar ciertos suplementos o medicamentos por unas horas).",
				},
				{
					id: "ivf-step-2-fertility-testing-faq-3",
					question: "¿Qué pasa si un resultado sale fuera del rango normal?",
					answer:
						"Si algún resultado cae fuera del rango esperado — ya sea una AMH baja, FSH elevada, o un hallazgo en la ecografía uterina — la especialista explicará lo que significa en el contexto de tu situación específica. Un valor atípico raras veces cambia drásticamente el plan, pero puede llevar a ajustes de protocolo o pruebas adicionales.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Pruebas de fertilidad.",
		},
		{
			id: "ivf-step-3-treatment-preparation",
			order: 3,
			title: "Preparación del tratamiento",
			description:
				"Este paso cubre los preparativos antes del ciclo — consentimientos, configuración financiera y capacitación práctica de medicación, para que todo esté listo antes del Día 1.",
			estimatedDateRange: "Est. Apr 14 – Apr 20, 2026 [Pre-cycle, before CD1]",
			estimatedStartDate: "2026-04-14",
			status: "completed",
			subSteps: [
				{
					id: "ivf-step-3-treatment-preparation-ss-01",
					title: "Configuración financiera y de seguro",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss-02",
					title: "Documentación de consentimiento",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss-03",
					title: "Capacitación de medicación y revisión del protocolo",
				},
			],
			highlight: {
				dayCount: "5–7 días",
				monitoringSchedule:
					"Firma todos los formularios de consentimiento antes del día 1 del ciclo; Asiste a la capacitación de auto-inyección antes de comenzar la estimulación",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Aprender a auto-inyectarse es una fuente común de ansiedad. La mayoría se siente significativamente más segura tras una sesión de capacitación — las agujas son mucho más finas de lo esperado.",
				milestone: "Protocolo firmado y medicación lista, est. 20 abr",
				currentDayLabel: "Día [N] de ~7",
				estimatedLengthDays: 7,
			},
			tasks: [
				{
					id: "ivf-step-3-treatment-preparation-ss1-task1",
					title: "Completar: Formulario de verificación de seguro",
					description: "Confirma tu cobertura de fertilidad con tu proveedor",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-3-treatment-preparation-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
					progressTotal: 4,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss1-task2",
					title: "Reservar: Llamada con agente del seguro",
					description: "Discute tu cobertura para este ciclo de tratamiento",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-3-treatment-preparation-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss1-task3",
					title: "Revisar y firmar: Acuerdo financiero",
					description: "Desglose de costos y términos de pago",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-3-treatment-preparation-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss1-task4",
					title: "Subir: Autorización del seguro",
					description: "Carta de autorización previa de tu aseguradora",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-3-treatment-preparation-ss-01",
					subStepTitle: "Configuración financiera y de seguro",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss2-task1",
					title: "Revisar y firmar: Consentimiento general",
					description: "Términos y permisos estándar de la clínica",
					category: "clinical",
					deadline: "Antes de comenzar el tratamiento",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-3-treatment-preparation-ss-02",
					subStepTitle: "Documentación de consentimiento",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss2-task2",
					title: "Revisar y firmar: Consentimiento informado para FIV",
					description:
						"Riesgos, beneficios y alternativas del procedimiento de FIV",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-3-treatment-preparation-ss-02",
					subStepTitle: "Documentación de consentimiento",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss2-task3",
					title: "Revisar y firmar: Consentimiento de medicación",
					description:
						"Reconoce tus riesgos de medicación y plan de dosificación",
					category: "medication",
					deadline: "Antes de comenzar la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-3-treatment-preparation-ss-02",
					subStepTitle: "Documentación de consentimiento",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss2-task4",
					title: "Revisar y firmar: Consentimiento de criopreservación",
					description:
						"Términos de almacenamiento de embriones y derechos de decisión",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-3-treatment-preparation-ss-02",
					subStepTitle: "Documentación de consentimiento",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss3-task1",
					title: "Revisar y firmar: Protocolo de tratamiento",
					description: "Tu plan personalizado de estimulación",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-3-treatment-preparation-ss-03",
					subStepTitle: "Capacitación de medicación y revisión del protocolo",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss3-task2",
					title: "Reservar: Capacitación de auto-inyección",
					description: "Aprende a administrar tus medicamentos de estimulación",
					category: "medication",
					deadline: "Antes de comenzar la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-3-treatment-preparation-ss-03",
					subStepTitle: "Capacitación de medicación y revisión del protocolo",
				},
				{
					id: "ivf-step-3-treatment-preparation-ss3-task3",
					title: "Reservar: Reunión con coordinadora",
					description: "Repasa tu plan antes de que comience el ciclo",
					category: "clinical",
					deadline: "Antes del día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-3-treatment-preparation-ss-03",
					subStepTitle: "Capacitación de medicación y revisión del protocolo",
				},
			],
			faqs: [
				{
					id: "ivf-step-3-treatment-preparation-faq-1",
					question: "¿En qué consiste el proceso de consentimiento informado?",
					answer:
						"El consentimiento informado cubre los riesgos y beneficios de cada procedimiento — estimulación, recuperación de óvulos y transferencia de embriones — así como decisiones sobre almacenamiento de embriones, uso futuro, donación o disposición. Es importante leerlo con calma y hacer preguntas antes de firmar, no solo cumplir el trámite.",
				},
				{
					id: "ivf-step-3-treatment-preparation-faq-2",
					question: "¿Qué pasa si el seguro no cubre el tratamiento?",
					answer:
						"Muchos ciclos de FIV son parcial o totalmente autofinanciados. La coordinadora financiera de la clínica puede explicar el desglose completo de costos y las opciones de pago o financiamiento disponibles. Algunos empleadores ofrecen beneficios de fertilidad — vale la pena consultar con RR.HH.",
				},
				{
					id: "ivf-step-3-treatment-preparation-faq-3",
					question: "¿Cómo funciona la capacitación de auto-inyección?",
					answer:
						"La enfermera de la clínica revisará cada paso en una cita dedicada — cómo preparar la medicación, dónde y cómo inyectar, y qué observar. Puntos prácticos clave: dejar que la medicación alcance temperatura ambiente durante 15 minutos antes de inyectar, rotar los sitios de inyección y mantener un calendario constante.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Preparación del tratamiento.",
		},
		{
			id: "ivf-step-4-ovarian-stimulation",
			order: 4,
			title: "Estimulación ovárica",
			description:
				"Este paso usa inyecciones hormonales diarias para estimular los ovarios y desarrollar múltiples folículos. El equipo clínico monitorea la respuesta cada 2–3 días y ajusta la dosis según los resultados.",
			estimatedDateRange: "Est. Apr 21 – May 2, 2026 [CD1–CD14]",
			estimatedStartDate: "2026-04-21",
			status: "completed",
			subSteps: [
				{
					id: "ivf-step-4-ovarian-stimulation-ss-01",
					title: "Inicio del ciclo y línea base",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss-02",
					title: "Inyecciones diarias",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss-03",
					title: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss-04",
					title: "Inyección desencadenante",
				},
			],
			highlight: {
				dayCount: "10–14 días",
				monitoringSchedule:
					"Inyecciones diarias cada noche a la misma hora; Ecografía de monitoreo cada 2–3 días; Notifica a la clínica inmediatamente cuando empiece tu período (Día 1)",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Cambios de ánimo, hinchazón y fatiga son comunes durante la estimulación — señales de que el cuerpo está respondiendo. Muchas personas encuentran útil mantener las noches libres alrededor de la hora de inyección.",
				milestone: "Inyección desencadenante, est. 2 may",
				currentDayLabel: "Día [N] de ~12",
				estimatedLengthDays: 12,
			},
			tasks: [
				{
					id: "ivf-step-4-ovarian-stimulation-ss1-task1",
					title: "Notificar: Período comenzó — Día 1",
					description: "Registra el día 1 para iniciar tu protocolo",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-01",
					subStepTitle: "Inicio del ciclo y línea base",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss1-task2",
					title: "Reservar: Ecografía basal — Día 2–3",
					description: "Confirma que los ovarios están listos para estimular",
					category: "cycle",
					deadline: "En el día 1 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-01",
					subStepTitle: "Inicio del ciclo y línea base",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss1-task3",
					title: "Análisis: Ecografía basal",
					description:
						"Confirma ovarios despejados antes de iniciar inyecciones",
					category: "clinical",
					deadline: "Día 2 o 3 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-01",
					subStepTitle: "Inicio del ciclo y línea base",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss2-task1",
					title: "Notificar: Medicación iniciada",
					description: "Confirma que tu primera inyección fue administrada",
					category: "medication",
					deadline: "Día 1 de la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-02",
					subStepTitle: "Inyecciones diarias",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss2-task2",
					title: "Monitorear: Efectos de la medicación",
					description: "Registra a diario tu respuesta a las inyecciones",
					category: "medication",
					deadline: "A diario durante la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-02",
					subStepTitle: "Inyecciones diarias",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss2-task3",
					title: "Notificar: Síntoma nuevo o efecto secundario",
					description: "Reporta cualquier cosa inesperada a tu clínica",
					category: "clinical",
					deadline: "En cuanto ocurra",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-02",
					subStepTitle: "Inyecciones diarias",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task1",
					title: "Reservar: Ecografía de monitoreo — Día 6",
					description: "Primera verificación folicular durante la estimulación",
					category: "clinical",
					deadline: "Antes del día 5 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task2",
					title: "Reservar: Ecografía de monitoreo — Día 8",
					description: "Segunda verificación folicular durante la estimulación",
					category: "clinical",
					deadline: "Antes del día 7 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task3",
					title: "Reservar: Ecografía de monitoreo — Día 10",
					description: "Evaluación folicular final antes del desencadenante",
					category: "clinical",
					deadline: "Antes del día 9 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task4",
					title: "Análisis: Visita de monitoreo — Ecografía y sangre",
					description: "Tamaño folicular, conteo y niveles hormonales",
					category: "clinical",
					deadline: "Días 6, 8 y 10 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task5",
					title: "Monitorear: Crecimiento folicular",
					description: "Rastrea el tamaño y conteo folicular entre ecografías",
					category: "clinical",
					deadline: "A diario durante la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task6",
					title: "Monitorear: Niveles hormonales — E2, P4 y LH",
					description:
						"Rastrea las tendencias de E2, P4 y LH durante la estimulación",
					category: "clinical",
					deadline: "A diario durante la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task7",
					title: "Monitorear: Síntomas del ciclo",
					description: "Registra hinchazón, cólicos y manchado a diario",
					category: "cycle",
					deadline: "Durante toda la estimulación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss3-task8",
					title: "Reservar: Llamada de revisión de medicación",
					description:
						"Ajuste de dosis basado en los resultados de la ecografía",
					category: "medication",
					deadline: "Después de cada ecografía de monitoreo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-03",
					subStepTitle: "Visitas de monitoreo",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss4-task1",
					title: "Reservar: Recuperación de óvulos",
					description:
						"Programa la recuperación ~36 hrs después de la inyección",
					category: "clinical",
					deadline: "Alrededor del día 11–12 del ciclo",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-04",
					subStepTitle: "Inyección desencadenante",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-ss4-task2",
					title: "Notificar: Inyección desencadenante administrada",
					description: "Confirma que tu inyección de hCG fue a tiempo",
					category: "medication",
					deadline: "La misma noche de la inyección",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-4-ovarian-stimulation-ss-04",
					subStepTitle: "Inyección desencadenante",
				},
			],
			faqs: [
				{
					id: "ivf-step-4-ovarian-stimulation-faq-1",
					question: "¿Las inyecciones diarias serán dolorosas?",
					answer:
						"La mayoría de las pacientes lo describen como un breve pinchazo y leve ardor — las agujas son muy finas y van justo bajo la piel. Dejar que la medicación alcance temperatura ambiente durante 15 minutos antes de inyectar y rotar los sitios suele reducir significativamente las molestias.",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-faq-2",
					question: "¿Cuántos óvulos producirá la estimulación?",
					answer:
						"El número de folículos que se desarrollan varía según la reserva ovárica, la edad y la respuesta individual a la estimulación. Las visitas de monitoreo rastrean el conteo y tamaño folicular para que el equipo pueda optimizar la respuesta. La cantidad final solo se conoce el día de la recuperación.",
				},
				{
					id: "ivf-step-4-ovarian-stimulation-faq-3",
					question: "¿Qué es el SHO y cómo se maneja?",
					answer:
						"El Síndrome de Hiperestimulación Ovárica (SHO) es una condición donde los ovarios responden en exceso a la estimulación, causando hinchazón y molestias. El SHO leve es relativamente común y se resuelve por sí solo. El equipo monitorea cuidadosamente para reducir el riesgo y puede ajustar el protocolo si es necesario.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Estimulación ovárica.",
		},
		{
			id: "ivf-step-5-egg-retrieval",
			order: 5,
			title: "Recuperación de óvulos",
			description:
				"Este es el día del procedimiento. Bajo sedación ligera, los óvulos maduros se recolectan de los folículos usando una aguja fina guiada por ecografía. La mayoría de las pacientes están en casa descansando en pocas horas.",
			estimatedDateRange:
				"Est. May 3, 2026 [CD14–CD16, ~36 hrs after trigger shot]",
			estimatedStartDate: "2026-05-03",
			status: "completed",
			subSteps: [
				{
					id: "ivf-step-5-egg-retrieval-ss-01",
					title: "Preparación previa a la recuperación",
				},
				{
					id: "ivf-step-5-egg-retrieval-ss-02",
					title: "Procedimiento de recuperación",
				},
				{
					id: "ivf-step-5-egg-retrieval-ss-03",
					title: "Recuperación posterior",
				},
			],
			highlight: {
				dayCount: "1 días",
				monitoringSchedule:
					"Completa la lista previa al procedimiento el día anterior; Organiza un acompañante para conducir a casa tras la sedación",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Es común sentir una mezcla de alivio e intensidad emocional tras la recuperación. La recuperación física suele ser rápida — descansar es lo único requerido el resto del día.",
				milestone: "Recuperación completada, est. 3 may",
				currentDayLabel: "Día 1 de 1",
				estimatedLengthDays: 1,
			},
			tasks: [
				{
					id: "ivf-step-5-egg-retrieval-ss1-task1",
					title: "Revisar y firmar: Consentimiento de recuperación",
					description:
						"Riesgos del procedimiento, sedación y términos de cancelación",
					category: "clinical",
					deadline: "Antes del día de la recuperación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-5-egg-retrieval-ss-01",
					subStepTitle: "Preparación previa a la recuperación",
				},
				{
					id: "ivf-step-5-egg-retrieval-ss1-task2",
					title: "Completar: Lista previa al procedimiento",
					description:
						"Ayuno, medicación e instrucciones de llegada confirmadas",
					category: "clinical",
					deadline: "Día antes de la recuperación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-5-egg-retrieval-ss-01",
					subStepTitle: "Preparación previa a la recuperación",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-5-egg-retrieval-ss2-task1",
					title: "Análisis: Procedimiento de recuperación de óvulos",
					description:
						"Aspiración folicular guiada por ecografía bajo sedación",
					category: "clinical",
					deadline: "Día de recuperación — a la hora reservada",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-5-egg-retrieval-ss-02",
					subStepTitle: "Procedimiento de recuperación",
				},
				{
					id: "ivf-step-5-egg-retrieval-ss3-task1",
					title: "Monitorear: Síntomas post-recuperación",
					description:
						"Registra hinchazón, cólicos y manchado tras el procedimiento",
					category: "clinical",
					deadline: "24–48 horas post-recuperación",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-5-egg-retrieval-ss-03",
					subStepTitle: "Recuperación posterior",
				},
				{
					id: "ivf-step-5-egg-retrieval-ss3-task2",
					title: "Notificar: Síntoma nuevo o efecto secundario",
					description: "Reporta signos de SHO o dolor inesperado a tu clínica",
					category: "clinical",
					deadline: "En cuanto ocurra",
					status: "completed",
					progress: 100,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-5-egg-retrieval-ss-03",
					subStepTitle: "Recuperación posterior",
				},
			],
			faqs: [
				{
					id: "ivf-step-5-egg-retrieval-faq-1",
					question: "¿Qué implica realmente el día de la recuperación?",
					answer:
						"El procedimiento toma aproximadamente 20–30 minutos bajo sedación ligera. Tras llegar en ayuno, las pacientes descansan en recuperación 1–2 horas antes de irse a casa. Cólicos leves e hinchazón en las siguientes 24–48 horas son comunes y manejables con analgésicos sin receta.",
				},
				{
					id: "ivf-step-5-egg-retrieval-faq-2",
					question: "¿Cuántos óvulos es realista esperar?",
					answer:
						"No todos los folículos contienen un óvulo maduro, y no todos los óvulos recuperados serán adecuados para la fertilización. La clínica compartirá el conteo de óvulos inmediatamente tras el procedimiento. Es útil tomar cada etapa como información, no como un destino final.",
				},
				{
					id: "ivf-step-5-egg-retrieval-faq-3",
					question: "¿Cuáles son los riesgos asociados a la recuperación?",
					answer:
						"La recuperación de óvulos es un procedimiento bien establecido y de bajo riesgo. Las consideraciones principales incluyen sangrado leve, un pequeño riesgo de infección y, raramente, lesión de estructuras circundantes. La detección previa exhaustiva minimiza estos riesgos. Cualquier síntoma significativo después debe reportarse a la clínica.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Recuperación de óvulos.",
		},
		{
			id: "ivf-step-6-embryo-development",
			order: 6,
			title: "Desarrollo embrionario",
			description:
				"Durante 5–6 días, los óvulos fertilizados se cultivan en el laboratorio de embriología y se monitorean mientras se desarrollan en blastocistos. Las actualizaciones clave llegan el Día 1, Día 3 y Día 5–6.",
			estimatedDateRange: "Est. May 4 – May 9, 2026 [Day 1–6 post retrieval]",
			estimatedStartDate: "2026-05-04",
			status: "current",
			subSteps: [
				{
					id: "ivf-step-6-embryo-development-ss-01",
					title: "Reporte de fertilización",
				},
				{
					id: "ivf-step-6-embryo-development-ss-02",
					title: "Cultivo de embriones y actualizaciones",
				},
				{
					id: "ivf-step-6-embryo-development-ss-03",
					title: "Pruebas genéticas PGT-A (opcional)",
				},
				{
					id: "ivf-step-6-embryo-development-ss-04",
					title: "Calificación de embriones y almacenamiento",
				},
			],
			highlight: {
				dayCount: "5–6 días",
				monitoringSchedule:
					"Monitorea las actualizaciones de desarrollo embrionario diariamente en la app; Decide sobre las pruebas PGT-A antes del Día 5",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"No todos los óvulos fertilizados llegan a la etapa de blastocisto — esto es parte natural del proceso, no una señal de que algo salió mal. Muchas personas encuentran las actualizaciones diarias tranquilizadoras y difíciles a la vez.",
				milestone: "Reporte de blastocisto, est. 9 may",
				currentDayLabel: "Día [N] de ~6",
				estimatedLengthDays: 6,
			},
			tasks: [
				{
					id: "ivf-step-6-embryo-development-ss1-task1",
					title: "Notificar: Reporte de fertilización recibido",
					description:
						"Informa a tu equipo que el reporte de fertilización está listo",
					category: "clinical",
					deadline: "Día 1 post-recuperación — mañana",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-6-embryo-development-ss-01",
					subStepTitle: "Reporte de fertilización",
				},
				{
					id: "ivf-step-6-embryo-development-ss1-task2",
					title: "Subir: Reporte de fertilización",
					description: "Número de óvulos fertilizados normalmente (2PN)",
					category: "clinical",
					deadline: "Día 1 post-recuperación — mismo día",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-6-embryo-development-ss-01",
					subStepTitle: "Reporte de fertilización",
				},
				{
					id: "ivf-step-6-embryo-development-ss2-task1",
					title: "Monitorear: Actualizaciones del desarrollo embrionario",
					description:
						"Rastrea actualizaciones diarias del progreso embrionario",
					category: "clinical",
					deadline: "Días 1–6 post-recuperación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-6-embryo-development-ss-02",
					subStepTitle: "Cultivo de embriones y actualizaciones",
				},
				{
					id: "ivf-step-6-embryo-development-ss3-task1",
					title: "Revisar y firmar: Consentimiento PGT-A",
					description:
						"Pruebas genéticas opcionales para detección cromosómica",
					category: "clinical",
					deadline: "Antes del día de la biopsia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-6-embryo-development-ss-03",
					subStepTitle: "Pruebas genéticas PGT-A (opcional)",
				},
				{
					id: "ivf-step-6-embryo-development-ss3-task2",
					title: "Análisis: Biopsia embrionaria para PGT-A",
					description: "Biopsia de trofoectodermo para análisis cromosómico",
					category: "clinical",
					deadline: "Etapa de blastocisto día 5–7",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-6-embryo-development-ss-03",
					subStepTitle: "Pruebas genéticas PGT-A (opcional)",
				},
				{
					id: "ivf-step-6-embryo-development-ss3-task3",
					title: "Subir: Resultados PGT-A",
					description: "Estado cromosómico de cada embrión biopsiado",
					category: "clinical",
					deadline: "Cuando lleguen los resultados (~7–14 días)",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-6-embryo-development-ss-03",
					subStepTitle: "Pruebas genéticas PGT-A (opcional)",
				},
				{
					id: "ivf-step-6-embryo-development-ss4-task1",
					title: "Completar: Formulario de preferencia de almacenamiento",
					description:
						"Confirma tus instrucciones de criopreservación o descarte",
					category: "clinical",
					deadline: "Antes del día 6",
					status: "ongoing",
					progress: 75,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-6-embryo-development-ss-04",
					subStepTitle: "Calificación de embriones y almacenamiento",
					progressTotal: 4,
					progressUnit: "campos",
				},
			],
			faqs: [
				{
					id: "ivf-step-6-embryo-development-faq-1",
					question: "¿Qué les pasa a los óvulos en el laboratorio?",
					answer:
						"Tras la recuperación, los óvulos maduros se evalúan y fertilizan — ya sea mezclándolos con esperma (FIV convencional) o inyectando un solo espermatozoide directamente en cada óvulo (ICSI). Los óvulos fertilizados se colocan en incubadoras especiales y se monitorean a medida que se dividen y desarrollan en embriones.",
				},
				{
					id: "ivf-step-6-embryo-development-faq-2",
					question: "¿Por qué algunos embriones dejan de desarrollarse?",
					answer:
						"La atrición en cada etapa de desarrollo es parte natural y esperada del proceso de FIV, no un reflejo de algo hecho o no hecho. En promedio, aproximadamente el 70% de los óvulos maduros fertilizan normalmente, alrededor del 50% de los embriones llegan al día 3, y aproximadamente el 30–50% alcanzan la etapa de blastocisto.",
				},
				{
					id: "ivf-step-6-embryo-development-faq-3",
					question: "¿Vale la pena considerar las pruebas genéticas PGT-A?",
					answer:
						"PGT-A examina los embriones en busca de anomalías cromosómicas antes de la transferencia, con el objetivo de priorizar aquellos con mayor probabilidad de implantarse exitosamente. No se recomienda para todas — la especialista aconsejará según la edad, historial reproductivo y prioridades personales.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Desarrollo embrionario.",
		},
		{
			id: "ivf-step-7-embryo-transfer",
			order: 7,
			title: "Transferencia de embriones",
			description:
				"Este paso coloca uno o más embriones en el útero a través de un catéter delgado — un procedimiento rápido, generalmente indoloro, que marca el inicio de la espera de dos semanas.",
			estimatedDateRange:
				"Est. May 12 – May 14, 2026 [Day 3–5 post retrieval for fresh · or FET date]",
			estimatedStartDate: "2026-05-12",
			status: "future",
			subSteps: [
				{
					id: "ivf-step-7-embryo-transfer-ss-01",
					title: "Preparación de la transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss-02",
					title: "Procedimiento de transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss-03",
					title: "Medicación post-transferencia",
				},
			],
			highlight: {
				dayCount: "1–3 días",
				monitoringSchedule:
					"Completa el control del endometrio 1 semana antes de la transferencia; Completa la lista previa a la transferencia el día anterior; Comienza el soporte de progesterona desde el día de la transferencia",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"El día de la transferencia carga un peso particular — esperanza, ansiedad y anticipación juntas. Muchas personas encuentran útil traer a alguien, aunque sea solo para esperar.",
				milestone: "Transferencia de embriones completada, est. 14 may",
				currentDayLabel: "Día [N] de ~3",
				estimatedLengthDays: 3,
			},
			tasks: [
				{
					id: "ivf-step-7-embryo-transfer-ss1-task1",
					title: "Reservar: Control del endometrio",
					description: "Evaluación del grosor y patrón del endometrio",
					category: "clinical",
					deadline: "~1 semana antes de la transferencia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-7-embryo-transfer-ss-01",
					subStepTitle: "Preparación de la transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss1-task2",
					title: "Análisis: Control del endometrio",
					description:
						"El endometrio debe alcanzar ≥7mm antes de la transferencia",
					category: "clinical",
					deadline: "~1 semana antes de la transferencia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-7-embryo-transfer-ss-01",
					subStepTitle: "Preparación de la transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss1-task3",
					title:
						"Revisar y firmar: Consentimiento de transferencia embrionaria",
					description: "Selección de embrión, riesgos y plan de almacenamiento",
					category: "clinical",
					deadline: "Antes del día de la transferencia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-7-embryo-transfer-ss-01",
					subStepTitle: "Preparación de la transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss1-task4",
					title: "Reservar: Transferencia de embriones",
					description: "Confirma fecha y hora de transferencia con tu equipo",
					category: "clinical",
					deadline: "3–5 días post-recuperación o fecha de FET",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-7-embryo-transfer-ss-01",
					subStepTitle: "Preparación de la transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss2-task1",
					title: "Completar: Lista previa a la transferencia",
					description:
						"Preparación de vejiga, medicación y llegada confirmadas",
					category: "clinical",
					deadline: "Día antes de la transferencia",
					status: "ongoing",
					progress: 60,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-7-embryo-transfer-ss-02",
					subStepTitle: "Procedimiento de transferencia",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss2-task2",
					title: "Análisis: Procedimiento de transferencia embrionaria",
					description:
						"Colocación del embrión en el útero guiada por ecografía",
					category: "clinical",
					deadline: "Día de transferencia — a la hora reservada",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-7-embryo-transfer-ss-02",
					subStepTitle: "Procedimiento de transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss3-task1",
					title: "Revisar y firmar: Protocolo de soporte de progesterona",
					description:
						"Instrucciones de dosificación de progesterona en fase lútea",
					category: "medication",
					deadline: "Día de transferencia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "review-sign",
					subStepId: "ivf-step-7-embryo-transfer-ss-03",
					subStepTitle: "Medicación post-transferencia",
				},
				{
					id: "ivf-step-7-embryo-transfer-ss3-task2",
					title: "Monitorear: Medicación de soporte de progesterona",
					description:
						"Registra dosis tomadas y rastrea cualquier efecto secundario",
					category: "medication",
					deadline: "Diario desde el día de transferencia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-7-embryo-transfer-ss-03",
					subStepTitle: "Medicación post-transferencia",
				},
			],
			faqs: [
				{
					id: "ivf-step-7-embryo-transfer-faq-1",
					question: "¿En qué consiste el procedimiento de transferencia?",
					answer:
						"La transferencia de embriones es un procedimiento ambulatorio que dura unos 15–20 minutos, típicamente sin sedación. Con la vejiga ligeramente llena para guiar la ecografía, el médico pasa un catéter suave a través del cuello uterino y deposita el embrión en el útero. La mayoría no siente más que un breve cólico.",
				},
				{
					id: "ivf-step-7-embryo-transfer-faq-2",
					question: "¿Cuántos embriones deberían transferirse?",
					answer:
						"La transferencia de un solo embrión (SET) es la recomendación estándar en la mayoría de los casos — particularmente para pacientes menores de 37 años con embriones de buena calidad. Transferir un solo embrión reduce significativamente el riesgo de embarazo múltiple sin reducir las tasas de éxito acumulativas.",
				},
				{
					id: "ivf-step-7-embryo-transfer-faq-3",
					question: "¿Qué hacer — y qué evitar — tras la transferencia?",
					answer:
						"Actividad diaria normal y suave es apropiada después de la transferencia. No es necesario reposo en cama. El ejercicio intenso, levantar pesos pesados y el alcohol deben evitarse. Todos los medicamentos prescritos — especialmente el soporte de progesterona — deben continuarse exactamente según las indicaciones.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Transferencia de embriones.",
		},
		{
			id: "ivf-step-8-two-week-wait",
			order: 8,
			title: "Espera de dos semanas",
			description:
				"Este paso es el período de espera entre la transferencia de embriones y el análisis de embarazo. Las medicaciones continúan, los síntomas se registran y el apoyo está disponible en todo momento.",
			estimatedDateRange: "Est. May 14 – May 28, 2026 [Day 1–14 post transfer]",
			estimatedStartDate: "2026-05-14",
			status: "future",
			subSteps: [
				{
					id: "ivf-step-8-two-week-wait-ss-01",
					title: "Continuación de progesterona",
				},
				{
					id: "ivf-step-8-two-week-wait-ss-02",
					title: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "ivf-step-8-two-week-wait-ss-03",
					title: "Apoyo emocional",
				},
				{
					id: "ivf-step-8-two-week-wait-ss-04",
					title: "Reserva del análisis Beta hCG",
				},
			],
			highlight: {
				dayCount: "10–14 días",
				monitoringSchedule:
					"Soporte de progesterona diario — no suspender sin instrucción de la clínica; Registra síntomas a diario en la app; Reserva el análisis Beta hCG en el Día 10–14 post-transferencia",
				staffInfo: "Enfermera B. Chen",
				headsUpNote:
					"La espera de dos semanas se considera ampliamente una de las partes más difíciles de la FIV. Los síntomas — o su ausencia — no pueden predecir el resultado de manera confiable. No es algo que deba interpretarse demasiado.",
				milestone: "Análisis Beta hCG, est. 28 may",
				currentDayLabel: "Día [N] de ~14",
				estimatedLengthDays: 14,
			},
			tasks: [
				{
					id: "ivf-step-8-two-week-wait-ss1-task1",
					title: "Monitorear: Efectos de la medicación",
					description:
						"Registra tu respuesta diaria al soporte de progesterona",
					category: "medication",
					deadline: "A diario durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-8-two-week-wait-ss-01",
					subStepTitle: "Continuación de progesterona",
				},
				{
					id: "ivf-step-8-two-week-wait-ss2-task1",
					title: "Monitorear: Síntomas de la espera",
					description:
						"Rastrea cólicos, manchado y signos tempranos de embarazo",
					category: "clinical",
					deadline: "A diario durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-8-two-week-wait-ss-02",
					subStepTitle: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "ivf-step-8-two-week-wait-ss2-task2",
					title: "Monitorear: Bienestar y ánimo",
					description:
						"Chequeo emocional diario durante la espera de dos semanas",
					category: "cycle",
					deadline: "A diario durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "monitor",
					subStepId: "ivf-step-8-two-week-wait-ss-02",
					subStepTitle: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "ivf-step-8-two-week-wait-ss2-task3",
					title: "Notificar: Síntoma nuevo o efecto secundario",
					description: "Reporta sangrado abundante o dolor severo de inmediato",
					category: "clinical",
					deadline: "En cuanto ocurra",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-8-two-week-wait-ss-02",
					subStepTitle: "Monitoreo de síntomas y bienestar",
				},
				{
					id: "ivf-step-8-two-week-wait-ss3-task1",
					title: "Reservar: Sesión de apoyo emocional",
					description: "Habla con una psicóloga de tu equipo de cuidado",
					category: "cycle",
					deadline: "En cualquier momento durante la espera",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-8-two-week-wait-ss-03",
					subStepTitle: "Apoyo emocional",
				},
				{
					id: "ivf-step-8-two-week-wait-ss4-task1",
					title: "Reservar: Análisis de embarazo — Beta hCG",
					description: "Confirma el embarazo tras tu transferencia embrionaria",
					category: "clinical",
					deadline: "10–14 días post-transferencia",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-8-two-week-wait-ss-04",
					subStepTitle: "Reserva del análisis Beta hCG",
				},
			],
			faqs: [
				{
					id: "ivf-step-8-two-week-wait-faq-1",
					question:
						"¿Se recomienda hacer un test casero de embarazo durante la espera?",
					answer:
						"Los tests caseros generalmente no se recomiendan durante este período. Pueden ocurrir falsos positivos por hCG residual de la inyección desencadenante aún en el sistema, y falsos negativos pueden aparecer porque los niveles aún no son detectables. El análisis clínico de sangre es mucho más preciso.",
				},
				{
					id: "ivf-step-8-two-week-wait-faq-2",
					question: "¿Qué síntomas físicos son comunes en este paso?",
					answer:
						"Los síntomas durante la espera de dos semanas son en gran parte impulsados por la medicación de soporte de progesterona, no por si ha ocurrido implantación. Hinchazón, sensibilidad mamaria, manchado y fatiga son todos comunes y pueden aparecer independientemente del resultado. Sangrado abundante, fiebre o dolor severo deben reportarse rápidamente.",
				},
				{
					id: "ivf-step-8-two-week-wait-faq-3",
					question: "¿Cómo manejan las personas la espera emocional?",
					answer:
						"No hay un solo enfoque que funcione para todas. Mantenerse suavemente activa, apoyarse en alguien de confianza, limitar el tiempo en foros de fertilidad donde los resultados no son representativos, y usar la sesión de consejería incluida en este paso son todas estrategias que muchas personas encuentran útiles.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Espera de dos semanas.",
		},
		{
			id: "ivf-step-9-pregnancy-test",
			order: 9,
			title: "Prueba de embarazo",
			description:
				"Este es el día del análisis de embarazo. Sea cual sea el resultado, el equipo de cuidado está aquí — para apoyar los próximos pasos hacia adelante, o para revisar el ciclo y planear lo que sigue.",
			estimatedDateRange:
				"Est. May 28, 2026 [Day 14 post transfer · CD28–CD30]",
			estimatedStartDate: "2026-05-28",
			status: "future",
			subSteps: [
				{
					id: "ivf-step-9-pregnancy-test-ss-01",
					title: "Análisis de sangre Beta hCG",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss-02",
					title: "Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss-03",
					title: "Resultado negativo — revisión del ciclo",
				},
			],
			highlight: {
				dayCount: "1–3 días",
				monitoringSchedule:
					"Asiste al análisis Beta hCG en la fecha programada — no hagas la prueba antes; Sube el resultado y notifica a la clínica el mismo día; Reserva la ecografía de confirmación si es positivo",
				staffInfo: "Dra. T. Miller | Enfermera B. Chen",
				headsUpNote:
					"Hoy trae un resultado significativo — y emociones significativas en cualquier sentido. Tener a alguien disponible — para celebrar o para apoyar — es algo que muchas personas encuentran importante.",
				milestone: "Resultado Beta hCG, est. 28 may",
				currentDayLabel: "Día [N] de ~3",
				estimatedLengthDays: 3,
			},
			tasks: [
				{
					id: "ivf-step-9-pregnancy-test-ss1-task1",
					title: "Análisis: Análisis de embarazo — Beta hCG",
					description: "Confirma el embarazo tras tu transferencia embrionaria",
					category: "clinical",
					deadline: "14 días post-transferencia — a la hora reservada",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-9-pregnancy-test-ss-01",
					subStepTitle: "Análisis de sangre Beta hCG",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss1-task2",
					title: "Subir: Resultado de Beta hCG",
					description: "El resultado activa la vía positiva o negativa",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "upload",
					subStepId: "ivf-step-9-pregnancy-test-ss-01",
					subStepTitle: "Análisis de sangre Beta hCG",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss1-task3",
					title: "Notificar: Resultados recibidos",
					description:
						"Informa a tu equipo que tus resultados de Beta hCG están listos",
					category: "clinical",
					deadline: "El mismo día que llegan los resultados",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "notify",
					subStepId: "ivf-step-9-pregnancy-test-ss-01",
					subStepTitle: "Análisis de sangre Beta hCG",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss2-task1",
					title: "Reservar: Ecografía de confirmación",
					description:
						"Ecografía de confirmación del latido si la Beta hCG es positiva",
					category: "clinical",
					deadline: "~6–7 semanas de gestación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-9-pregnancy-test-ss-02",
					subStepTitle:
						"Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss2-task2",
					title: "Análisis: Ecografía de confirmación",
					description: "Confirma el saco gestacional, polo fetal y latido",
					category: "clinical",
					deadline: "~6–7 semanas de gestación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "test",
					subStepId: "ivf-step-9-pregnancy-test-ss-02",
					subStepTitle:
						"Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss2-task3",
					title: "Reservar: Cita de derivación a obstetra",
					description: "Transferencia de la clínica de fertilidad al obstetra",
					category: "clinical",
					deadline: "~8–10 semanas de gestación",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-9-pregnancy-test-ss-02",
					subStepTitle:
						"Resultado positivo — confirmación y derivación a obstetra",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss3-task1",
					title: "Completar: Formulario de revisión del ciclo",
					description:
						"Documenta los resultados de tu ciclo para revisión clínica",
					category: "clinical",
					deadline: "Dentro de 1 semana del resultado",
					status: "ongoing",
					progress: 60,
					source: "clinic",
					iconName: "fill",
					subStepId: "ivf-step-9-pregnancy-test-ss-03",
					subStepTitle: "Resultado negativo — revisión del ciclo",
					progressTotal: 5,
					progressUnit: "campos",
				},
				{
					id: "ivf-step-9-pregnancy-test-ss3-task2",
					title: "Reservar: Consulta de revisión del ciclo",
					description:
						"Discute tus resultados y próximos pasos con tu especialista",
					category: "clinical",
					deadline: "Dentro de 2 semanas del resultado",
					status: "ongoing",
					progress: 0,
					source: "clinic",
					iconName: "book",
					subStepId: "ivf-step-9-pregnancy-test-ss-03",
					subStepTitle: "Resultado negativo — revisión del ciclo",
				},
			],
			faqs: [
				{
					id: "ivf-step-9-pregnancy-test-faq-1",
					question: "¿Qué significa realmente el nivel de Beta hCG?",
					answer:
						"La Beta hCG es la hormona producida después de que un óvulo fertilizado se implanta. Un nivel superior a 25 mUI/mL generalmente se considera positivo, aunque los umbrales individuales de cada clínica varían. Un solo número es menos informativo que la tendencia — un análisis repetido a las 48 horas confirma si está aumentando adecuadamente.",
				},
				{
					id: "ivf-step-9-pregnancy-test-faq-2",
					question: "¿Qué pasa si el resultado es negativo?",
					answer:
						"Un resultado negativo es uno de los momentos más difíciles del proceso de FIV. Darse tiempo y espacio antes de pensar en próximos pasos es completamente válido. Una consulta de revisión del ciclo — generalmente dentro de 1–2 semanas — discute lo aprendido y si se justifican cambios de protocolo o un enfoque diferente.",
				},
				{
					id: "ivf-step-9-pregnancy-test-faq-3",
					question: "¿Qué pasa después de un resultado positivo?",
					answer:
						"Tras una Beta hCG positiva, un análisis repetido 48 horas después confirma que el nivel sube, seguido de una ecografía de confirmación a las 6–7 semanas para verificar el saco gestacional, polo fetal y latido cardíaco. Si se confirma, el cuidado se transfiere a un obstetra alrededor de las 8–10 semanas.",
				},
			],
			askEvePrompt:
				"Cuéntame más sobre qué esperar durante mi Prueba de embarazo.",
		},
	],
};
